<template>

  <div>

    <div class="drop-zone" :class="{ 'drop-zone-active': dragging }" @click="!disabled && $refs.fileInput.click()"
      @dragover.prevent="dragging = !disabled" @dragleave.prevent="dragging = false" @drop.prevent="handleDrop">

      <input type="file" ref="fileInput" style="display: none" multiple accept="image/jpeg,image/png,image/webp,image/gif,application/pdf" @change="handleFileInput" />

      <p class="drop-zone-title">Click to choose files, or drag them here</p>
      <p class="drop-zone-subtitle">JPG, PNG, WebP or PDF · up to {{ max_files }} files · max 20 MB · one photo per page works best</p>

    </div>

    <div class="file-list" v-if="value.length > 0">

      <div class="file" v-for="(file, index) in value" :key="file.name + index">
        <p>{{ index + 1 }}. {{ file.name }}</p>
        <img src="@/assets/delete_image.svg" @click="removeFile(index)" v-if="!disabled" />
      </div>

    </div>

  </div>

</template>


<script>
import { MAX_FILES, MAX_TOTAL_BYTES, isMenuFile } from './menuFiles'

// Drop zone + file list for menu photos / PDFs. Use with v-model; emits "error" when files are skipped.
export default {
  name: "MenuFilePicker",
  props: {
    value: { type: Array, required: true },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      dragging: false,
      max_files: MAX_FILES
    }
  },
  methods: {
    handleFileInput() {
      this.addFiles(this.$refs.fileInput.files)
      this.$refs.fileInput.value = ''
    },
    handleDrop(event) {
      this.dragging = false
      if (!this.disabled) {
        this.addFiles(event.dataTransfer.files)
      }
    },
    addFiles(fileList) {
      const supported = Array.from(fileList).filter(isMenuFile)
      // PDFs are uploaded as they are (photos get shrunk), so they're what can go over the 20 MB limit
      const pdfBytes = files => files.filter(file => file.type === 'application/pdf').reduce((sum, file) => sum + file.size, 0)
      const accepted = []
      let tooLarge = false
      supported.forEach(file => {
        if (pdfBytes([...this.value, ...accepted, file]) > MAX_TOTAL_BYTES) {
          tooLarge = true
        } else {
          accepted.push(file)
        }
      })
      let error = ''
      if (tooLarge) {
        error = 'Some files were skipped: the upload can be at most 20 MB. Try a smaller PDF, or photos of the pages.'
      } else if (supported.length < fileList.length) {
        error = 'Some files were skipped. Please upload JPG, PNG, WebP or PDF files.'
      }
      this.$emit('error', error)
      this.$emit('input', this.value.concat(accepted).slice(0, MAX_FILES))
    },
    removeFile(index) {
      this.$emit('input', this.value.filter((file, i) => i !== index))
    }
  }
}
</script>


<style scoped>

.drop-zone {
  margin-top: 50px;
  border: 1px dashed gray;
  box-sizing: border-box;
  padding: 50px 20px;
  text-align: center;
  cursor: pointer;
  background: white;
}

.drop-zone-active {
  border-color: rgba(39, 170, 225, 1);
  background: rgba(39, 170, 225, 0.1);
}

.drop-zone-title {
  font-weight: 600;
  margin: 0px 0px 10px 0px;
}

.drop-zone-subtitle {
  font-size: 12.5px;
  color: dimgray;
  margin: 0px;
}

.file-list {
  margin: 25px 0px;
}

.file {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.5px solid lightgray;
}

.file p {
  font-size: 13px;
  margin: 10px 0px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file img {
  width: 12px;
  height: 12px;
  cursor: pointer;
  margin-left: 10px;
}

</style>
